<template>
    <div>
        <WZRankedOverlay :params="params" :game="game" />
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import axios from 'axios';
import WZRankedOverlay from '../components/WZRankedOverlay.vue';

export default {
  name: 'NukeOverlay',
  components: {
    WZRankedOverlay,
  },

  data() {
    return {
      params: null,
      game: null,
    };
  },

  created() {
    // this.game = this.$route.params.game;
    this.init();
    this.timer = setInterval(this.init, 5000);
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    init() {
      const { uid } = this.$route.params;
      // const {game} = this.$route.params;
      axios.get(`https://api.wzhub.gg/api/top250/${uid}`).then((response) => {
        if (response.data.success) {
          this.params = response.data.data.overlay;
          this.game = response.data.game;
        } else {
          clearInterval(this.timer);
          this.params = null;
        }
      });
    },
  },
};
</script>
